import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));
export default function EditEventTypeModal({
  openModal,
  typeId,
  typeName,
  func,
  clientId,
}) {
  const classes = useStyles();
  const [name, setName] = useState(typeName);
  const [processing, setProcessing] = useState(false);
  const [showInputError, setShowInputError] = useState(false);

  const json = {
    Id: typeId,
    ClientId: clientId,
    Name: name,
  };

  const checkAllEntered = () => {
    if (name === "") {
      return false;
    }
    return true;
  };

  const callFunc = (json) => {
    if (checkAllEntered()) {
      func(json).then(() => {
        openModal(false);
      });
    } else {
      setShowInputError(true);
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Edit Event Type
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Add Name"
                  label="Add Name"
                  variant="standard"
                  fullWidth
                  required
                  error={showInputError}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => callFunc(json)}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
